<template>
 <div class="main__section">
        <sidebar></sidebar>
        <div class="detailedstep">
            <div class="detailedstep__form">
                    <p class="detailedstep__title">Business information</p>
                    <div class="preview" :style="{ 'background-image': `url(${form.company_logo_preview})` }">
                        <p>Company Logo/Product Pic</p>
                        <label for="company-logo" class="preview__label">Upload</label>
                        <input type="file" name="company_logo" accept="image/*" ref="logo" id="company-logo" class="preview__input" @change="handleFileUpload('logo')" />
                    </div>

                    <div class="preview preview--full" :style="{ 'background-image': `url(${form.cover_image_preview})` }">
                        <p>Cover/Header image</p>
                        <label for="company-cover" class="preview__label">Upload</label>
                        <input type="file"  name="company_cover" accept="image/*" ref="header" id="company-cover" class="preview__input" @change="handleFileUpload('header')"/>
                    </div>
                    <p class="detailedstep__title detailedstep__title--gray">At least 1280x480 pixels wide</p>
                

                    <p class="detailedstep__title">Social Media</p>
                    <div class="detailedstep__input">
                        <input type="text" name="linkedin" placeholder="Linkedin" class="input__text" v-model="form.linkedin"/>
                    </div>
                    <div class="detailedstep__input">
                        <input type="text" name="facebook" placeholder="Facebook" class="input__text" v-model="form.facebook"/>
                    </div>
                    <div class="detailedstep__input">
                        <input type="text" name="twitter" placeholder="Twitter" class="input__text" v-model="form.twitter"/>
                    </div>
                    <div class="detailedstep__input">
                        <input type="text" name="instagram" placeholder="Instagram" class="input__text" v-model="form.instagram"/>
                    </div>
                    <div class="detailedstep__input">
                        <input type="text" name="youtube" placeholder="Youtube" class="input__text" v-model="form.youtube"/>
                    </div>
                    <div class="detailedstep__input">
                        <input type="text" name="blogurl" placeholder="Blog URL" class="input__text" v-model="form.blog"/>
                    </div>

                    <div class="detailedstep__form detailedstep__form--two">
                        <a href="#" class="button__next button__next--fixed text-white" @click.prevent="goBack()">Back</a>
                        <a href="#" class="button__next text-white" @click.prevent="saveData()">Next Step</a>
                    </div> 

            </div>
        </div>
        <single-testimonial></single-testimonial>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
import SingleTestimonial from '../testimonials/SingleTestimonial';
import Sidebar from '../sidebar/Sidebar';

export default {
     components:{
        'sidebar':Sidebar,
        'single-testimonial':SingleTestimonial
    },
    data(){
        return{
            form:{
                company_logo:null,
                cover_image:null,
                company_logo_preview: null,
                cover_image_preview: null,
                linkedin:'',
                facebook:'',
                twitter:'',
                instagram:'',
                youtube:'',
                blog:''
            }
        }
    },    
    methods:{

        ...mapActions([
            'saveCompanyProfile',
            'changeStep'
        ]),
    handleFileUpload(ref){
        let attr = ref == 'logo' ? 'company_logo' : 'cover_image';
        this.form[attr] = this.$refs[ref].files[0];

        let reader  = new FileReader();

        reader.addEventListener("load", function () {
            this.form[attr + '_preview'] = reader.result;
        }.bind(this), false);

        if( this.form[attr] ){
            if ( /\.(jpe?g|png|gif)$/i.test( this.form[attr].name ) ) {
                reader.readAsDataURL( this.form[attr] );
            }
        }
    },
        pickFile (e) {
         let selectedImage = (e.target.id == 'company-logo') ? true : false;  
        // let file = e.target.files
        // if (file && file[0]) {
        //   let reader = new FileReader();
        //   reader.readAsDataURL(file[0]);
        //   reader.onload = e => {
              if(selectedImage){
                   this.form.company_logo = e.target.files[0];
              }else{
                   this.form.cover_image = e.target.files[0];
              }
           
        //   }
        //
        //
        // }
    },
    saveData(){
        this.saveCompanyProfile(this.form);
    },
    goBack(){
        this.changeStep(1);
    }
}
}
</script>
